import { useNavigate } from 'react-router-dom';
import { Badge, InlineStack, Button } from '@shopify/polaris';
import { useScanContext } from '../providers/ScanContext';

/**
 * T031: ScanStatusPill component.
 * Shows "Scan running • View progress" linked to the progress screen.
 * Visible on all pages while a scan is active.
 */
export function ScanStatusPill() {
  const navigate = useNavigate();
  const { activeJobId, isScanning } = useScanContext();

  if (!isScanning || !activeJobId) {
    return null;
  }

  return (
    <InlineStack gap="200" blockAlign="center">
      <Badge tone="attention" progress="partiallyComplete">
        Scan running
      </Badge>
      <Button
        variant="plain"
        size="slim"
        onClick={() => navigate(`/scan-progress/${activeJobId}`)}
      >
        View progress
      </Button>
    </InlineStack>
  );
}
